//文字大小
class TxtZoom {
  constructor() {
    this.txtZoom = $('#txtZoom');
    this.txtarea = $('.txtZoomArea');
  }
  zoom() {
    this.txtZoom.find('button').each((i, e) => {
      //預設為小
      if(i == 2){
        $(e).addClass('active');
      }
      $(e).on('click', () => {
        this.txtZoom.find('button').removeClass('active');
        $(e).addClass('active');
        if(i == 0){
          //大
          this.txtarea.css({
            lineHeight: '40px',
            fontSize  : '20px' 
          });
        }else if(i == 1){
          //中
          this.txtarea.css({
            lineHeight: '40px',
            fontSize  : '18px' 
          });
        }else if(i == 2){
          this.txtarea.css({
            lineHeight: '30px',
            fontSize  : '16px' 
          });
        }
      });
    });
  }
}




//輸出
export {TxtZoom};


// WEBPACK FOOTER //
// ./js_new/txt_zoom.js